import { render, staticRenderFns } from "./CustomerProfileDescriptionActionCell.vue?vue&type=template&id=0cb8464c&"
import script from "./CustomerProfileDescriptionActionCell.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileDescriptionActionCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports